
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorMapIecIcon as ObiCursorMapIecIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-map-iec-icon.js';
 
 
 

 
 export const ObiCursorMapIecIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-map-iec-icon',
   elementClass: ObiCursorMapIecIconElement,
   events: {
     
   }
  });
 
 